/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = exports.Item = function () {
  function Item(item) {
    _classCallCheck(this, Item);

    this.item = item;
    this.state = {
      active: false
    };
  }

  _createClass(Item, [{
    key: 'activate',
    value: function activate() {
      this.state.active = true;
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.state.active = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _utils.applyClasses)({
        'Accordion-title': true,
        'is-active': this.state.active
      });

      return '\n      <dt class="' + classes + '">' + this.item.title + '</dt>\n      <dd class="Accordion-description">\n        <p class="Accordion-text">' + this.item.description + '</p>\n      </dd>\n      <dd class="Accordion-separator" aria-hidden="true"></dd>\n    ';
    }
  }]);

  return Item;
}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Errors = __webpack_require__(8);

Object.keys(_Errors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Errors[key];
    }
  });
});

var _Renderer = __webpack_require__(2);

Object.keys(_Renderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Renderer[key];
    }
  });
});

var _applyClasses = __webpack_require__(9);

Object.keys(_applyClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _applyClasses[key];
    }
  });
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Renderer = exports.Renderer = function () {
  function Renderer(querySelector) {
    _classCallCheck(this, Renderer);

    this.node = document.querySelector(querySelector);
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render(html) {
      if (this.node !== null) {
        this.node.innerHTML = html;
      }
    }
  }]);

  return Renderer;
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _src = __webpack_require__(5);

__webpack_require__(10);
__webpack_require__(11);

var accordion = new _src.Accordion({
  querySelector: '#app',
  items: [new _src.Item({
    title: 'FrontEnd Developer',
    description: 'In charge of the JS and CSS of the site...'
  }), new _src.Item({
    title: 'Backend Developer',
    description: 'In charge of the Database and all the logic in our business...'
  }), new _src.Item({
    title: 'Product Owner',
    description: 'In charge of making the business decisions and transform it in user histories...'
  })],
  activeIndex: 0
});

accordion.init();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = __webpack_require__(6);

Object.keys(_Accordion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Accordion[key];
    }
  });
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = __webpack_require__(7);

Object.keys(_Accordion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Accordion[key];
    }
  });
});

var _Item = __webpack_require__(0);

Object.keys(_Item).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Item[key];
    }
  });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Item = __webpack_require__(0);

var _utils = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Accordion = exports.Accordion = function () {
  function Accordion(options) {
    _classCallCheck(this, Accordion);

    this.options = options;
    this.WHITESPACE = '';
    this.SPACE = ' ';
    this.renderer = new _utils.Renderer(options.querySelector);
    this.errors = new _utils.Errors(this.renderer, this.constructor.name);
    this.selectors = {
      title: this.options.querySelector + this.SPACE + '.Accordion-title'
    };
  }

  _createClass(Accordion, [{
    key: 'init',
    value: function init() {
      var _options = this.options,
          activeIndex = _options.activeIndex,
          items = _options.items;

      var lengthItems = items.length;
      if (activeIndex >= lengthItems) {
        this.errors.renderError('The activeIndex property is ' + activeIndex + ' \n          should be less than the length of the items which is ' + items.length);
        return;
      }
      items[activeIndex].activate();
      this.render();
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      var _this = this;

      var titles = document.querySelectorAll(this.selectors.title);

      titles.forEach(function (element, index) {
        element.addEventListener('click', _this.toggle.bind(_this, index), false);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(index) {
      var findIndex = this.options.items.findIndex(function (item) {
        return item.state.active;
      });
      this.options.items[findIndex].deactivate();
      this.options.items[index].activate();
      this.render();
    }
  }, {
    key: 'render',
    value: function render() {
      var html = this.renderAccordion();
      this.renderer.render(html);
      this.initEvents();
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      return this.options.items.map(function (item) {
        return item.render();
      }).join(this.WHITESPACE);
    }
  }, {
    key: 'renderAccordion',
    value: function renderAccordion() {
      return '\n    <dl class="Accordion">\n      ' + this.renderItems() + '\n    </dl>\n    ';
    }
  }]);

  return Accordion;
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Errors = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Renderer = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Errors = exports.Errors = function () {
  function Errors(renderer, className) {
    _classCallCheck(this, Errors);

    this.renderer = renderer;
    this.className = className;
  }

  _createClass(Errors, [{
    key: 'renderError',
    value: function renderError(message) {
      var error = '<p class="error">' + message + '</p>';
      var template = '<h2 class="error-text">' + this.className + ' Errors</h2>';
      template += error;
      this.renderer.render(template);
    }
  }]);

  return Errors;
}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyClasses = applyClasses;
function applyClasses(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key] ? key : '';
  }).filter(function (item) {
    return item !== '';
  }).join(' ').trim();
}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/main.758a07fa7cdf7d0f1596.js